import { Dayjs } from "dayjs"
import { IAddress } from "@/models/address/address.types"
import { ICustomer } from "../customer/customer.types"
import { Status } from "@/types/Status"

export enum AccountStatuses {
  ACTIVE = "ACTIVE",
  NOT_ON_SUPPLY = "NOT_ON_SUPPLY",
  TERMINATING = "TERMINATING",
  CLOSED = "CLOSED",
  CANCELLED = "CANCELLED",
}

export interface IAccount {
  number: string
  juniferId: number
  name: string
  balance: number
  billingAddress?: IAddress
  createdTime: Dayjs
  startDate: Dayjs
  juniferCustomerId?: number
  endDate?: Dayjs
  supplyAddress?: IAddress
  id?: number
  juniferPropertyId?: number
  cancelled?: boolean
  customer?: ICustomer
  firstName?: string
  lastName?: string

  readonly status: Status
  readonly isActive: boolean
  readonly isTerminating: boolean
  readonly balanceStatus: Status
  readonly accountAge: string
  readonly formattedName: string
}
